import React, {useState} from 'react';
import './WhiteboardV2.scss';

const WhiteboardActionModal = ({canvasName, selectedObject, onClose, onCreate, onOpenPlanning, isSubmitting, createdTask}) => {
    const defaultTitle = selectedObject?.actionText || selectedObject?.text || 'Nouvelle action depuis le Tableau Blanc';
    const [title, setTitle] = useState(defaultTitle);
    const [description, setDescription] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [priority, setPriority] = useState(2);
    const [error, setError] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!title.trim()) {
            setError('L’intitulé de l’action est requis.');
            return;
        }
        setError('');
        try {
            await onCreate({
                title: title.trim(),
                description: description.trim(),
                due_date: dueDate || null,
                priority,
                object_id: selectedObject?.objectId || null,
                object_snapshot: selectedObject ? {
                    type: selectedObject.customType || selectedObject.type,
                    text: selectedObject.actionText || selectedObject.text || null,
                    left: Math.round(selectedObject.left || 0),
                    top: Math.round(selectedObject.top || 0),
                } : null,
            });
        } catch (requestError) {
            setError(requestError?.response?.data?.message || 'La création de l’action a échoué.');
        }
    };

    return <div className="wbActionModalOverlay" onMouseDown={onClose} role="presentation">
        <form className="wbActionModal" onSubmit={handleSubmit} onMouseDown={event => event.stopPropagation()}>
            <header>
                <div><span>DU TABLEAU À L’ACTION</span><h2>Créer dans le Planning</h2></div>
                <button type="button" onClick={onClose} aria-label="Fermer">×</button>
            </header>
            {createdTask ? <section className="wbActionSuccess">
                <strong>Action créée dans {createdTask.planning_name}</strong>
                <p>{createdTask.title}</p>
                <button type="button" className="wbPrimary" onClick={() => onOpenPlanning(createdTask)}>Ouvrir dans le Planning →</button>
                <button type="button" className="wbSecondary" onClick={onClose}>Fermer</button>
            </section> : <>
                <p className="wbActionContext">Cette action conserve le lien avec le canevas <strong>{canvasName}</strong>{selectedObject ? ' et l’élément sélectionné.' : '.'}</p>
                <label>Intitulé<input value={title} onChange={event => setTitle(event.target.value)} maxLength="191" autoFocus/></label>
                <div className="wbActionGrid">
                    <label>Échéance<input type="date" value={dueDate} onChange={event => setDueDate(event.target.value)}/></label>
                    <label>Priorité<select value={priority} onChange={event => setPriority(Number(event.target.value))}>
                        <option value={1}>Basse</option><option value={2}>Normale</option><option value={3}>Haute</option><option value={4}>Critique</option>
                    </select></label>
                </div>
                <label>Décision / contexte<textarea rows="4" value={description} onChange={event => setDescription(event.target.value)} placeholder="Précisez l’action à réaliser…" maxLength="2000"/></label>
                {error && <p className="wbFormError">{error}</p>}
                <footer><button type="button" className="wbSecondary" onClick={onClose}>Annuler</button><button className="wbPrimary" type="submit" disabled={isSubmitting}>{isSubmitting ? 'Création…' : 'Créer l’action →'}</button></footer>
            </>}
        </form>
    </div>;
};

export default WhiteboardActionModal;
